
import { Component, Input, OnInit, output } from '@angular/core';
import { DeleteConfirmationComponent } from 'src/app/modules/shared/components/delete-confirmation/delete-confirmation.component';

@Component({
    selector: 'app-role-request-cart',
    imports: [DeleteConfirmationComponent],
    templateUrl: './role-request-cart.component.html',
    styleUrl: './role-request-cart.component.css'
})
export class RoleRequestCartComponent implements OnInit {
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() rolesOnCart: any[] = [];
  readonly removeRole = output<any>();
  showConfirmation = false;
  roleToDelete = null;

  showRoleDirectly = false;
  showRoleSystem = false;
  showTextarea = false;
  showDelete = false;
  showCartInfo = false;
  action = 'List';

  constructor() { }

  ngOnInit(): void {}

  onRemoveRole(role) {
    this.showConfirmation = true;
    this.roleToDelete = role;
  }

  cancel() {
    this.roleToDelete = null;
    this.showConfirmation = false;
  }

  confirm() {
    this.removeRole.emit(this.roleToDelete);
    this.showConfirmation = false;
  }

  toggleshowTextarea() {
    this.showTextarea = !this.showTextarea;
  }

  toggleRoleDirectly() {
    this.showRoleDirectly = true;
    this.showRoleSystem = false;
  }

  toggleRoleSystem() {
    this.showRoleSystem = true;
    this.showRoleDirectly = false;
  }

  toggleDelete() {
    this.showDelete = true;
    this.showCartInfo = false;
  }

  toggleCartInfo() {
    this.showCartInfo = !this.showCartInfo;
  }

  delete() {
    if (this.action === 'Delete') {
      this.action = 'List';
      this.showDelete = true;
    } else {
      this.action = 'Delete';
      this.showCartInfo = false;
    }
  }
}
